import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect, useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { InputSearch, NormalButton } from "component/common";
import { Navbar } from "./backend";
import { AiOutlineRight, AiOutlineDown } from "react-icons/ai";
export default class BackendClass extends Component {
  state = {
    formFields: {
      projectTitle: "",
      projectDesc: "",
      status: "",
      custName: "",
      contactName: "",
      contactNumber: "",
    },
    // scheduleOptions: [],
    projectList: [],
    statusOption: [],
    // locationOption: [],
    // levelList: [],
    is_loading: true,
    isMounted: true,
    showDropdown: false,
    activeIndex: -1,

    currentValue: 0,
    // navLinks: [
    //   { to: "/admin/project/add", label: "Activities", id: "Activities" },
    //   { to: "/admin/project/add", label: "Quotation", id: "Quotation" },
    //   { to: "/admin/project/add", label: "Purchase Order", id: "PO" },
    // ],
    navLinks: [
      {
        to: this.props.location.pathname,
        label: "Activities",
        id: "Activities",
      },
      { to: this.props.location.pathname, label: "Quotation", id: "Quotation" },
      { to: this.props.location.pathname, label: "Purchase Order", id: "PO" },
    ],
    selectedMenu: "Activities",
  };
  toggleDropdown = (index) => {
    this.setState((prevState) => ({
      activeIndex: prevState.activeIndex === index ? -1 : index,
    }));
    console.log(index, "index");
  };
  handleChange = (link) => {
    this.props.history.push(link);
    console.log(link, "Link");
  };
  render() {
    let { t } = this.props;
    const Heading = [
      {
        // image: btc,
        title: "Item Master",
        time: "Nov 12, 2019 11:34 PM",
        link: "/admin/backend/itemmaster",
      },
      {
        // image: outlet,
        title: "Item Classification",

        children: [
          {
            title: "Division",
            link: "/admin/backend/itemclassification/division",
          },
          {
            title: "Department",
            link: "/admin/backend/itemclassification/department",
          },
          {
            title: "Class",
            link: "/admin/backend/itemclassification/itemclasslist",
          },
          {
            title: "Brand",
            link: "/admin/backend/itemclassification/brandlist",
          },
          {
            title: "UOM",
            link: "/admin/backend/itemclassification/uom",
          },
          {
            title: "Commission",
            link: "/admin/backend/itemclassification/commissionlist",
          },
        ],
      },
      {
        title: "Range",

        children: [
          {
            title: "product",
            link: "/admin/backend/itemclassification/rangeproduct",
          },
          {
            title: "Service",
            link: "/admin/backend/itemclassification/range/itemclassservice",
          },
          {
            title: t("Voucher"),
            link: "/admin/backend/itemclassification/range/classvoucher",
          },
          {
            title: t("Prepaid"),
            link: "/admin/backend/itemclassification/range/itemclassprepaid",
          },
          {
            title: t("Compound"),
            link: "/admin/backend/itemclassification/range/itemclasscompound",
          },
        ],
      },
      {
        //image: stockdetail,
        title: "Appointment Config",
        time: "Nov 12, 2019 11:34 PM",

        children: [
          {
            title: "Equipment",
            link: "/admin/backend/appointment/equipment",
          },
          {
            title: "Room",
            link: "/admin/backend/appointment/room",
          },
          {
            title: "Appointment Block Reason",
            link: "/admin/backend/appointment/blockreason",
          },
          {
            title: t("Appointment Group"),
            link: "/admin/backend/appointment/appointmentgroup",
          },
          {
            title: t("Booking Status"),
            link: "/admin/backend/appointment/booking",
          },
          {
            title: t("Channel"),
            link: "/admin/backend/appointment/appointmentchannel",
          },
          {
            title: t("Secondary Status"),
            link: "/admin/backend/appointment/secondary",
          },
        ],
      },
      {
        //image: salessource,
        title: "Treatment",
        time: "Nov 12, 2019 11:34 PM",

        children: [
          {
            title: "Adjustment Reason",
            link: "/admin/backend/treatment/adjustmentreason",
          },
          {
            title: "Diagnosis ",
            link: "/admin/backend/treatment/diagnosis",
          },
        ],
      },
      {
        //image: salessource,
        title: "Sales",
        time: "Nov 12, 2019 11:34 PM",

        children: [
          {
            title: "Item Status Group",
            link: "/admin/backend/sales/itemstatusgroup",
          },
          {
            title: "Item Status",
            link: "/admin/backend/sales/itemstatus",
          },
          {
            title: "Discount Reason",
            link: "/admin/backend/sales/discountreason",
          },
          {
            title: t("FOC Reason"),
            link: "/admin/backend/sales/focreason",
          },
          {
            title: t("Payment Group"),
            link: "/admin/backend/sales/paymentgroup",
          },
          {
            title: t("Payment Type"),
            link: "/admin/backend/sales/paymenttype",
          },
        ],
      },
      {
        //image: salessource,
        title: "Config Interface",

        children: [
          {
            title: "Occupation Type",
            link: "/admin/backend/configinterface/occupationtype",
          },
          {
            title: "Source",
            link: "/admin/backend/configinterface/configsource",
          },
          {
            title: "Transaction Reason",
            link: "/admin/backend/configinterface/transactionreason",
          },
          {
            title: t("VOID Reason"),
            link: "/admin/backend/configinterface/transactionvoid",
          },
        ],
      },
      {
        //image: salessource,
        title: "Business Hours",
        time: "Nov 12, 2019 11:34 PM",
        link: "/admin/backend/businesshours",
      },
      {
        //image: productionsales,
        title: "Tax Type",
        link: "/admin/backend/taxtype",
      },

      {
        //image: salesdepartment,
        title: "Outlet Master",
        time: "Nov 12, 2019 11:34 PM",
        link: "/admin/backend/outletmaster",
      },

      {
        //image: stockmovement,
        title: "Customer Master - I",
        time: "Nov 12, 2019 11:34 PM",
        link: "/admin/backend/customermasterone",
      },

      {
        //image: stockbalance,
        title: "Customer Master - II",
        time: "Nov 12, 2019 11:34 PM",
        link: "/admin/backend/customermastertwo",
      },

      {
        //image: salessource,
        title: "Normal Reward Policy",
        time: "Nov 12, 2019 11:34 PM",
        link: "/admin/backend/normalrewardpolicy",
      },

      {
        //image: salessource,
        title: "Redeem Policy",

        link: "/admin/backend/redeempolicy",
      },

      {
        //image: salessource,
        title: "Bonus Reward",
        time: "Nov 12, 2019 11:34 PM",
        link: "/admin/backend/bonusreward",
      },

      {
        //image: salessource,
        title: "Vendor Master",
        time: "Nov 12, 2019 11:34 PM",
        link: "/admin/backend/vendormaster",
      },
      {
        //image: salessource,
        title: "Country Setting",
        time: "Nov 12, 2019 11:34 PM",
        link: "/admin/backend/countrysetting",
      },
      {
        //image: salessource,
        title: "Employee Master",
        time: "Nov 12, 2019 11:34 PM",
        link: "/admin/backend/employeemaster",
      },
      {
        title: "Security Master",
        link: "/admin/backend/securitymaster",
      },
      {
        title: "Invoice Template Upload",
        link: "/admin/backend/invoicetemplete",
      },
      {
        title: "SMTP Settings",
        link: "/admin/backend/smtpsetting",
      },
      {
        title: "Catalog Settings",
        link: "/admin/backend/catalogsetting",
      },
      {
        title: "Import Balance",
        link: "/admin/backend/imports",
      },
      {
        title: "Customer Retention Period",
        link: "/admin/backend/customer-retention",
      },
      {
        title: "E-Invoice Setup",
        link: "/admin/backend/einvoice",
      },
      {
        title: "MGM Policy",
        link: "/admin/backend/mgm-policy",
      },
    ];

    return (
      <div className="col-md-12 ">
        <div className="container-fluid bg-white px-md-5 my-3">
          <div className="py-5">
            <p className="fs-16 mb-3">
              <span className="font-weight-bold px-1 ml-4 ">HOME</span>/BACKEND
            </p>
            {/* <h2 className="my-4 ml-4 main-title">Back End</h2>
            <p className="font-weight-normal fs-16 ml-4">
              See full list of your backend reports here
            </p>
            <div className="row my-3 d-flex ">
              <div className="col-md-4 font-weight-bold">
                <Navbar />
              </div>
            </div> */}

            <div className="card-head ">
              {Heading.map((item, index) => {
                const isActive = this.state.activeIndex === index;
                const hasChildren = item.children && item.children.length > 0;

                return (
                  // <div className="col-lg-6 ">
                  <div className="col-md-6 col-sm-12 " key={index}>
                    <div className="card ">
                      <div
                        className="card-body row d-flex justify-content-between align-items-center"
                        onClick={() => this.toggleDropdown(index)}
                      >
                        <div className="col-md-6 ">
                          <p className="card-title">{item.title}</p>
                          {/* <p>{item.time}</p> */}
                        </div>

                        <div className="col-md-6 col-sm-2 mt-2  text-center">
                          {hasChildren && isActive ? (
                            <AiOutlineDown />
                          ) : hasChildren && !isActive ? (
                            <AiOutlineRight />
                          ) : (
                            <NormalButton
                              backend={true}
                              label={"View"}
                              onClick={() => this.handleChange(item.link)}
                            />
                          )}
                        </div>
                      </div>
                      {isActive && (
                        <div className=" col-md-12 mb-2">
                          {console.log(item.children, "itemChild")}
                          {item.children &&
                            item.children.map((child, index) => (
                              <div className="col-md-12 mt-2 d-flex justify-content-between align-items-center">
                                <div className="col-md-6">
                                  <p className="child-title">{child.title}</p>
                                </div>
                                <div className="col-md-6">
                                  <NormalButton
                                    backend_child={true}
                                    label={"View"}
                                    onClick={() =>
                                      this.handleChange(child.link)
                                    }
                                  />
                                </div>
                                {/* <p>{item.time}</p> */}
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  </div>
                  // </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export const Backend = withTranslation()(
  connect(null, mapDispatchToProps)(BackendClass)
);
